import { graphql, useStaticQuery } from 'gatsby'
import { useCurrentLanguageKey } from '../context/i18n'
import { defaultLanguage } from '../../../config/storyblok/languages'
import { useStoryblok } from '../storyblok'
import { ContactPanelProps } from '../../modules/ContactPanel/types'

export const useContactFormData = (uuid: string) => {
  const query = graphql`
    {
      contactFormData: allStoryblokEntry(filter: { field_component: { eq: "ContactPanel" } }) {
        nodes {
          uuid
          id
          name
          slug
          full_slug
          lang
          created_at
          published_at
          first_published_at
          field_pageTitle_string
          field_pageDescription_string
          full_slug
          default_full_slug
          content
          translated_slugs {
            name
            lang
            path
          }
        }
      }
    }
  `

  const res = useStaticQuery(query)
  const currentLanguage = useCurrentLanguageKey()
  const { contactFormData } = res || {}
  const filteredData = contactFormData.nodes
    .filter(formData => {
      if (currentLanguage == defaultLanguage) {
        return formData.lang === 'default'
      }

      return formData.lang === currentLanguage
    })
    .filter(formdata => formdata.uuid === uuid)

  const { content } = useStoryblok(filteredData[0])

  return content as ContactPanelProps
}
